export default [
  {
    path: '/parametrizacao-template-proposta',
    component: {
      name: 'template-proposta-root',
      template: '<router-view />',
      meta: {
        resource: 'template-proposta',
        action: 'read',
        requiredAuth: true,
        breadcrumb: [
          { text: '', to: { path: '/' } },
        ],
      },
    },
    children: [
      {
        path: 'visualizar',
        name: 'template-proposta',
        component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplateProposta/template/ParametrizacaoTemplateProposta.vue'),
        meta: {
          resource: 'template-proposta',
          action: 'read',
          pageTitle: 'Template da Proposta',
          breadcrumb: [
            {
              text: 'Templates',
              to: { name: 'template-proposta' },
              active: true,
            },
          ],
        },
      },
      {
        path: 'novo',
        name: 'novo-template-proposta',
        component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplateProposta/components/cadastro-template/EditorCadastroProposta.vue'),
        meta: {
          resource: 'template-proposta',
          action: 'create',
          requiredAuth: true,
          navActiveLink: 'template-proposta',
          pageTitle: 'Template da Proposta',
          breadcrumb: [
            {
              text: 'Templates',
              to: { name: 'template-proposta' },
            },
            {
              text: 'novo',
              to: { name: 'novo-template-proposta' },
              active: true,
            },
          ],
        },
      },
      {
        path: 'editar/:id',
        name: 'editar-template-proposta',
        component: () => import('@/app-modulo/comercial/Parametrizacao/ParametrizacaoTemplateProposta/components/cadastro-template/EditorCadastroProposta.vue'),
        meta: {
          resource: 'template-proposta',
          action: 'update',
          requiredAuth: true,
          navActiveLink: 'template-proposta',
          pageTitle: 'Template da Proposta',
          breadcrumb: [
            {
              text: 'Templates',
              to: { name: 'template-proposta' },
            },
            {
              text: 'editar',
              to: { name: 'editar-template-proposta' },
              active: true,
            },
          ],
        },
      },
    ],
  },
]
